import { IoHomeSharp } from "react-icons/io5";
import { IoSettings } from "react-icons/io5";
import { MdLibraryMusic } from "react-icons/md";
import { LuCandlestickChart } from "react-icons/lu";
import { FaWallet } from "react-icons/fa6";
import { GiWallet } from "react-icons/gi";
import { FaUpload } from "react-icons/fa";
// import { IoHomeSharp } from "react-icons/io5";
import { FaUsers } from "react-icons/fa6";

import { LuActivity } from "react-icons/lu";
import aibot from "./assets/aibot.jpg";
import increase from "./assets/increase.jpg";
import { FaLocationDot } from "react-icons/fa6";
import expert from "./assets/expert.jpg";
import preventhacker from "./assets/preventhacker.jpg";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdManageAccounts } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import user1 from "./assets/user1.jpeg";
import user2 from "./assets/user2.jpeg";
import user3 from "./assets/user3.jpeg";
import user4 from "./assets/user4.jpeg";
import user5 from "./assets/user5.jpeg";
import { SiLetsencrypt } from "react-icons/si";
import { FaBuildingShield } from "react-icons/fa6";
import { GrSecure } from "react-icons/gr";
import { IoPricetag } from "react-icons/io5";

import { RiSettingsFill } from "react-icons/ri";
import { FaDatabase } from "react-icons/fa";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import { BsFillWalletFill } from "react-icons/bs";
import { FaBtc } from "react-icons/fa";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import ShieldIcon from "@mui/icons-material/Shield";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import InsightsIcon from "@mui/icons-material/Insights";
import LockIcon from "@mui/icons-material/Lock";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { IoBriefcase } from "react-icons/io5";
import { FaChartBar } from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";
import { FaCrown } from "react-icons/fa6";
import { FaMedal } from "react-icons/fa";
import { GrMoney } from "react-icons/gr";
import { IoDiamond } from "react-icons/io5";
import { GiMiner } from "react-icons/gi";

// SITE NAME
export const domain = "Valorcrypt";

// CONTACT USibcdjd

export const contactusData = [
  {
    name: "Phone",
    icon: <BsFillTelephoneFill />,
    value: "+123-450-7698",
    id: 1,
  },
  { name: "Email", icon: <MdEmail />, value: `support@${domain}.com`, id: 2 },
  {
    name: "Address",
    icon: <FaLocationDot />,
    value: "14 Scotsburn Rd, Tanerdy city, United Kingdom  ",
    id: 3,
  },
];

// ABOUT US DATA

export const team = [
  {
    name: "Robert Cole",
    role: `${domain} Founder`,
    imgUrl: user1,
    msg: `Robert Cole is the founder of ${domain}, the nation’s leading provider of 100% independent grades on stocks, mutual funds and financial institutions, as well as one of the world’s most awarded trading and rating agency that grades cryptocurrencies. He founded his company in 1976, and thanks largely to his strict independence, has established a 60-year record of accuracy.`,
    id: 1,
  },
  {
    name: "Sean gray",
    role: "Megatrends & Supercycles Analyst",
    imgUrl: user2,
    msg: `Supercycles aren't daily occurrences. They happen in stages and can last for years. Sean gray identifies them early and mines for the most financially sound stocks within them. And he taps into the powerful ${domain} to help him do it.`,
    id: 2,
  },
  {
    name: "John Graebe",
    role: "Startup Investing Specialist",
    imgUrl: user3,
    msg: `John Graebe knows a great private-equity deal when he sees one. His specialty is finding red-hot, breakthrough companies and investing in them before venture capitalists get in. And now, in Deal Hunters Alliance, he shows our Members how they can do the same.`,
    id: 3,
  },
];

// UPDATE

export const updateData = [
  {
    head: "AI trading bot",
    msg: `An AI trading bot, such as the ${domain}, is a sophisticated tool designed to autonomously execute trades based on predefined algorithms and market conditions. These bots utilize advanced machine learning and artificial intelligence algorithms to analyze vast amounts of data quickly and make informed trading decisions in real-time. By leveraging the power of AI, ${domain} optimizes trading strategies, identifies profitable opportunities, and minimizes risks, making it a valuable asset for professional traders looking to streamline their trading activities and remain competitive in the fast-paced world of cryptocurrency trading.`,
    imgUrl: aibot,
    id: 1,
  },
  {
    head: "Expert Traders",
    msg: `Expert traders, especially those in the world of cryptocurrencies like ${domain}, possess a wealth of knowledge, experience, and skill that sets them apart in the financial markets. These individuals have honed their craft through years of studying market trends, mastering risk management strategies, and staying informed about the latest developments in the industry. With a meticulous approach to analyzing data and making informed decisions, expert traders like those at ${domain} demonstrate a high level of professionalism and expertise that allows them to navigate the complexities of the cryptocurrency market with confidence and precision.`,
    imgUrl: expert,

    id: 2,
  },
  {
    head: "Boost your profit margin by 25%",
    msg: `To boost profit margin by 25% within the cryptobull market, strategic planning and keen financial acumen are essential. By analyzing market trends, diversifying investment portfolios, and leveraging innovative technologies, companies can capitalize on the dynamic nature of the cryptobull landscape to maximize returns efficiently. Embracing a proactive approach to risk management and fostering strong partnerships within the industry will further solidify a competitive edge, driving sustained growth and profitability in the ever-evolving ${domain} sector.`,
    imgUrl: increase,

    id: 3,
  },
  {
    head: "Maximum security  ",
    msg: `When it comes to achieving maximum security for ${domain} investments, it is crucial to implement comprehensive measures to safeguard assets. Utilizing advanced encryption techniques, multi-factor authentication, and employing the services of top cybersecurity professionals are essential steps in fortifying the protection of valuable assets from potential threats. By prioritizing strict adherence to industry best practices and remaining vigilant against emerging security risks, investors can establish a robust defense mechanism to ensure the integrity and confidentiality of their ${domain} holdings.`,
    imgUrl: preventhacker,

    id: 4,
  },
];

// MILESTONE

export const milestone = [
  {
    head: "Aug 15th 2016",
    msg: `We proudly achieved the esteemed recognition of being one of the  best trading platform on August 15th, 2016. This accomplishment is a testament to the dedication and expertise of our team in creating a cutting-edge platform that meets the needs of our users. We are committed to providing a top-notch trading experience, and this prestigious award serves as a validation of our continuous efforts to excel in the financial industry.`,
    id: 1,
  },
  {
    head: "Feb 5th 2017",
    msg: `On February 5th, 2017, a security breach was successfully prevented, thanks to the prompt and vigilant actions of the cybersecurity team at ${domain}. Their expertise and dedication were crucial in identifying and neutralizing the threat before any sensitive data was compromised. This incident highlights the importance of having a skilled and proactive security team in place to safeguard against potential breaches and protect the integrity of sensitive information. Working with professionals like ${domain} can be a key component in maintaining a secure and resilient cybersecurity infrastructure.`,
    id: 2,
  },
  {
    head: "June 12th 2019",
    msg: `On June 12th, 2019, ${domain} stood out as one of the companies that traded the most digital assets in the market. With their strategic approach and expertise in the digital asset trading realm, ${domain} displayed a noteworthy commitment to navigating the complexities of the market. Their proficient trading activities on that day undoubtedly showcased their dedication to maximizing opportunities in the digital asset landscape with prominent professionalism.`,
    id: 3,
  },
  {
    head: "Oct 7th 2023 ",
    msg: `On October 7th, 2023, ${domain} was honored to be acknowledged as a company renowned for its exceptional accuracy in trade prediction. This recognition reaffirms our commitment to excellence and expertise in the financial market. We take immense pride in our dedication to providing reliable and precise trade predictions to our clients, and this recognition further motivates us to continue delivering high-quality services. We are grateful for this acknowledgment and look forward to further solidifying our reputation as a leading authority in trade prediction.`,
    id: 4,
  },
];

export const services = [
  {
    head: "Trading of digital assets ",
    msg: `We offer a robust environment for individuals to engage in buying and selling various digital assets with confidence and efficiency. By leveraging tools provided by ${domain}, investors can stay informed on market trends, make strategic decisions, and optimize their trading strategies. Embracing a professional mindset when trading digital assets can lead to more informed choices and potentially higher returns on investments.`,
    id: 1,
  },
  {
    head: "Trading signals",
    msg: `Trading signals are key indicators used by traders to make informed decisions in the volatile world of cryptocurrency trading. Utilizing tools like ${domain} can provide traders with valuable insights and analysis to help them navigate the complex and ever-changing market conditions. By following reliable trading signals, traders can streamline their decision-making process and increase their chances of success in the competitive digital asset market. It is essential to understand the nuances of the signals provided by platforms like ${domain} to maximize their utility and harness the power of data-driven strategies in the dynamic realm of crypto trading.`,
    id: 2,
  },
  {
    head: "Development of crypto trading bots",
    msg: `The development of a trading bot has become increasingly essential in today's dynamic financial markets, particularly in the realm of cryptocurrency trading like ${domain}. These automated systems use advanced algorithms to analyze market trends, execute trades, and manage risk effectively. By leveraging cutting-edge technology and real-time data, trading bots have the capacity to boost trading efficiency, minimize human error, and capitalize on market opportunities swiftly. Professional traders often rely on these sophisticated bots to enhance their trading strategies and stay competitive in the fast-paced world of digital assets, showcasing the evolution and importance of automated trading solutions like ${domain} in today's financial landscape.`,
    id: 3,
  },
  {
    head: "portfolio management",
    msg: `${domain} offers exceptional trading experts account management services with a professional touch. Our team of skilled professionals is dedicated to helping clients navigate the complexities of the financial markets with precision and expertise. With ${domain}, you can trust that your investments are in capable hands, ensuring a strategic approach tailored to your unique financial goals. Our commitment to professionalism and proficiency sets us apart in the world of cryptocurrency trading, providing you with the peace of mind and confidence needed to succeed in the rapidly evolving market.`,
    id: 4,
  },
];
// INVESTMENT PLANS

export const investmentPlans = [
  // {
  // 	name: "Regular Plan",
  // 	botName: "Bot 1",
  // 	CB: "Yes",
  // 	minAmount: "100",
  // 	maxAmount: "900",
  // 	ROI: 8,
  // 	RC: "5%",
  // 	icon: (
  // 		<IoBriefcase className="inline-block  mr-[0.5rem]  text-gray-500   text-[1.5rem]" />
  // 	),
  // 	id: 1,
  // },
  {
    name: "Standard Plan",
    botName: "Bot 2",

    CB: "Yes",
    minAmount: "3000",
    maxAmount: "9900",
    ROI: 5,
    RC: "2%",
    icon: (
      <FaChartBar className="inline-block  mr-[0.5rem]   text-gray-500   text-[1.5rem]" />
    ),
    id: 2,
  },
  {
    name: "Mega Plan",
    botName: "Bot 3",

    CB: "Yes",
    minAmount: "10000",
    maxAmount: "19900",
    ROI: 10,
    RC: "4%",
    icon: (
      <FaGlobe className="inline-block  mr-[0.5rem]   text-gray-500   text-[1.5rem]" />
    ),
    id: 3,
  },
  {
    name: "VIP Plan",
    botName: "Bot 4",

    CB: "Yes",
    minAmount: "20000",
    maxAmount: "99000",
    ROI: 14,
    RC: "6%",
    icon: (
      <FaCrown className="inline-block  mr-[0.5rem]   text-gray-500  text-[1.5rem]" />
    ),
    id: 4,
  },
  {
    name: "Gold Plan",
    botName: "Bot 5",

    CB: "Yes",
    minAmount: "100000",
    maxAmount: "499000",
    ROI: 16,
    RC: "30%",
    icon: (
      <FaMedal className="inline-block  mr-[0.5rem]  text-gray-500    text-[1.5rem]" />
    ),
    id: 5,
  },
  {
    name: "Platinum Plan",
    botName: "Bot 6",

    CB: "Yes",
    minAmount: "500000",
    maxAmount: "1000000",
    ROI: 18,
    RC: "30%",
    icon: (
      <GrMoney className="inline-block  mr-[0.5rem] text-gray-500   text-[1.5rem]" />
    ),
    id: 6,
  },

  {
    name: "Diamond Plan",
    botName: "Bot 7",

    CB: "Yes",
    minAmount: "1000000",
    maxAmount: "100000000000000000000000000000000",
    ROI: 20,
    RC: "50%",
    icon: (
      <IoDiamond className="inline-block  mr-[0.5rem]  text-gray-500  text-[1.5rem]" />
    ),
    id: 7,
  },
];

// Q AND A DATA

// export const qAndA = [
// 	{
// 		name: "What is crypto mining?",
// 		desc: `Crypto mining is the process of validating and adding new transactions to a blockchain network, such as Bitcoin or Ethereum. Miners use powerful computers to solve complex mathematical problems, which helps secure the network and maintain its integrity. In return for their efforts, miners are rewarded with newly created cryptocurrency coins and transaction fees. Crypto mining plays a crucial role in the decentralized nature of blockchain technology, ensuring that transactions are verified and recorded in a transparent and tamper-proof manner.`,
// 		icon: (
// 			<IoBriefcase className="inline-block  mr-[0.5rem]  text-gray-500   text-[1.5rem]" />
// 		),
// 		id: 1,
// 	},
// 	{
// 		name: "How does crypto mining work?",
// 		desc: `Crypto mining works by utilizing specialized hardware and software to solve complex mathematical puzzles that validate transactions on a blockchain network. Miners compete to be the first to solve these puzzles, and the winner gets to add a new block of transactions to the blockchain. This process requires significant computational power and energy consumption, as miners must perform numerous calculations to find the correct solution. Once a block is added, it is verified by other nodes in the network, ensuring its validity. In return for their efforts, miners are rewarded with newly minted cryptocurrency coins and transaction fees, incentivizing them to continue supporting the network's security and integrity.`,
// 		icon: (
// 			<FaChartBar className="inline-block  mr-[0.5rem]   text-gray-500   text-[1.5rem]" />
// 		),
// 		id: 2,
// 	},
// 	{
// 		name: "what is crypto trading?",
// 		desc: `Crypto trading refers to the buying and selling of cryptocurrencies on various online platforms known as cryptocurrency exchanges. Traders aim to profit from the price fluctuations of digital assets like Bitcoin, Ethereum, and other altcoins by executing trades based on market analysis and trends. Crypto trading can be done through different methods, including spot trading, margin trading, and futures trading, each with its own level of risk and potential reward. Successful crypto traders often utilize technical analysis, fundamental analysis, and market sentiment to make informed decisions in this highly volatile and rapidly evolving market.`,
// 		icon: (
// 			<FaGlobe className="inline-block  mr-[0.5rem]   text-gray-500   text-[1.5rem]" />
// 		),
// 		id: 3,
// 	},
// 	{
// 		name: "what is a trading bot?",
// 		desc: `A trading bot is an automated software program that executes trades on behalf of traders in the financial markets, including cryptocurrencies. These bots use predefined algorithms and strategies to analyze market data, identify trading opportunities, and execute buy or sell orders without human intervention. Trading bots can operate 24/7, allowing traders to take advantage of market fluctuations even when they are not actively monitoring the markets. They can be programmed to follow specific trading strategies, such as trend following, arbitrage, or market making, and can help traders manage risk and improve their overall trading efficiency.`,
// 		icon: (
// 			<FaCrown className="inline-block  mr-[0.5rem]   text-gray-500  text-[1.5rem]" />
// 		),
// 		id: 4,
// 	},
// 	{
// 		name: "what is a mining bot?",
// 		desc: `A mining bot is an automated software program designed to facilitate the process of cryptocurrency mining. These bots are typically used to optimize and streamline the mining process by managing various tasks such as monitoring mining hardware, adjusting settings for optimal performance, and switching between different cryptocurrencies based on profitability. Mining bots can help miners maximize their earnings by automating routine tasks and ensuring that their mining operations run efficiently. They may also include features for tracking mining statistics, managing multiple mining rigs, and integrating with mining pools to enhance overall productivity.`,
// 		icon: (
// 			<FaMedal className="inline-block  mr-[0.5rem]  text-gray-500    text-[1.5rem]" />
// 		),
// 		id: 5,
// 	},
// 	{
// 		name: "what is Valorcrypt?",
// 		desc: `${domain} is a cutting-edge cryptocurrency trading platform that leverages advanced algorithms and artificial intelligence to provide users with a seamless and efficient trading experience. With a focus on security, transparency, and user-friendly design, ${domain} offers a range of features including real-time market analysis, automated trading bots, and comprehensive portfolio management tools. Whether you're a seasoned trader or just starting out in the world of digital assets, ${domain} aims to empower users to make informed decisions and maximize their investment potential in the rapidly evolving cryptocurrency market.`,
// 		icon: (
// 			<GrMoney className="inline-block  mr-[0.5rem] text-gray-500   text-[1.5rem]" />
// 		),
// 		id: 6,
// 	},

// 	{
// 		name: "Benefits of investing with Valaorcrypt?",
// 		desc: `Investing with ${domain} offers several benefits, including access to advanced trading tools and algorithms that can help optimize investment strategies. The platform provides a user-friendly interface, making it easy for both beginners and experienced traders to navigate the cryptocurrency market. Additionally, ${domain} emphasizes security and transparency, ensuring that users' funds and personal information are protected. With features such as automated trading bots, real-time market analysis, and comprehensive portfolio management, ${domain} aims to empower investors to make informed decisions and maximize their returns in the dynamic world of digital assets.`,
// 		icon: (
// 			<IoDiamond className="inline-block  mr-[0.5rem]  text-gray-500  text-[1.5rem]" />
// 		),
// 		id: 7,
// 	},
// ];

export const qAndA = [
  {
    name: "What is blockchain mining?",
    desc: `Blockchain mining involves validating and recording new transactions onto a blockchain network like Bitcoin or Ethereum. Miners utilize powerful hardware to solve complex cryptographic problems, helping to secure the network and maintain its integrity. In return, they earn newly minted coins and transaction fees. Mining is essential for decentralization, ensuring transparent and tamper-proof transaction records.`,
    icon: (
      <IoBriefcase className="inline-block  mr-[0.5rem]  text-gray-500   text-[1.5rem]" />
    ),
    id: 1,
  },
  {
    name: "How does blockchain mining operate?",
    desc: `Mining operates through specialized equipment and software that solve intricate mathematical puzzles to confirm transactions. Miners compete to be the first to solve these puzzles, and the successful one adds a new block to the chain. This process demands significant computational power and energy. Once added, other network nodes verify the block's validity. Miners are rewarded with newly created coins and transaction fees, incentivizing continuous network support.`,
    icon: (
      <FaChartBar className="inline-block  mr-[0.5rem]   text-gray-500   text-[1.5rem]" />
    ),
    id: 2,
  },
  {
    name: "What is cryptocurrency trading?",
    desc: `Cryptocurrency trading involves buying and selling digital assets like Bitcoin and Ethereum on online exchanges. Traders seek to profit from price movements by analyzing market trends and executing trades. Methods include spot trading, margin trading, and futures trading, each with varying risk levels. Successful traders often rely on technical and fundamental analysis, as well as market sentiment, to make informed decisions in this volatile market.`,
    icon: (
      <FaGlobe className="inline-block  mr-[0.5rem]   text-gray-500   text-[1.5rem]" />
    ),
    id: 3,
  },
  {
    name: "What is a trading automation tool?",
    desc: `A trading automation tool, or trading bot, is software that executes trades automatically based on predefined strategies. These bots analyze market data, identify trading opportunities, and place buy or sell orders without human input. Operating 24/7, they enable traders to capitalize on market movements even when away. They can be programmed for various strategies such as trend following, arbitrage, or market making, helping traders improve efficiency and manage risks.`,
    icon: (
      <FaCrown className="inline-block  mr-[0.5rem]   text-gray-500  text-[1.5rem]" />
    ),
    id: 4,
  },
  {
    name: "What is a mining automation tool?",
    desc: `A mining bot is software that automates cryptocurrency mining tasks. It manages hardware settings, monitors performance, switches between cryptocurrencies based on profitability, and optimizes overall mining efficiency. Mining bots help maximize earnings by automating routine functions and tracking mining statistics. They often support multiple rigs and integrate with mining pools to boost productivity.`,
    icon: (
      <FaMedal className="inline-block  mr-[0.5rem]  text-gray-500    text-[1.5rem]" />
    ),
    id: 5,
  },
  {
    name: `What is ${domain}?`,
    desc: `${domain} is an innovative cryptocurrency trading platform that uses advanced algorithms and AI to deliver a seamless trading experience. Focused on security, transparency, and user-friendliness, ${domain} offers real-time market insights, automated trading tools, and portfolio management features. Whether you're experienced or new to crypto, ${domain} helps users make informed decisions and maximize their investment potential in the fast-changing crypto landscape.`,
    icon: (
      <GrMoney className="inline-block  mr-[0.5rem] text-gray-500   text-[1.5rem]" />
    ),
    id: 6,
  },
  {
    name: `Advantages of investing with ${domain}?`,
    desc: `Investing with ${domain} provides access to sophisticated trading tools and algorithms designed to optimize your investment strategies. The platform features an intuitive interface suitable for both beginners and experts. Emphasizing security and transparency, ${domain} safeguards your funds and data. With automated trading, real-time analytics, and portfolio management, ${domain} empowers investors to make informed decisions and maximize returns in the dynamic crypto market.`,
    icon: (
      <IoDiamond className="inline-block  mr-[0.5rem]  text-gray-500  text-[1.5rem]" />
    ),
    id: 7,
  },
];
// TESTIMONIAL DATA

export const userTestimonial = [
  {
    name: "Amelia",
    imgUrl: user1,
    msg: `Hey there! Guess what? I recently made a whopping 29% profit by investing in ${domain}! ${domain} is an exciting cryptocurrency that has definitely paid off for me.  If you're considering getting into the world of cryptocurrency, ${domain} might just be the way to go! `,
    id: 1,
  },
  {
    name: "Evelyn",
    imgUrl: user2,
    msg: `Seeing my investment grow by 45% has been such a thrill! It's amazing how a bit of smart investing can really make a difference. `,
    id: 2,
  },
  {
    name: "Dave",
    imgUrl: user3,
    msg: ` I just had an exciting experience with ${domain} - I made an amazing 56% profit from my investment. ${domain} indeed worth my five stars. `,
    id: 3,
  },
  {
    name: "Lisa",
    imgUrl: user4,
    msg: `I feel so happy for the profit i made here in ${domain}. Indeed ${domain} is the right go to for me and i would recommend them to anyone that wants to earn from the digital world .`,
    id: 4,
  },
  {
    name: "Ava",
    imgUrl: user5,
    msg: `Big thanks to ${domain}, i never regreted having been here. `,
    id: 5,
  },
];

export const numberData = [
  { name: "$2.7 billion", msg: "Trading volume from Jan - Dec 2023", id: 1 },
  { name: "488,233", msg: "Clients withdrawal from Jan - Dec 2023", id: 2 },
  { name: "$2.7 billion", msg: "Active clients from Jan - Dec 2023", id: 3 },
  { name: "$95.7 million", msg: "Partner reward in Q3 2023", id: 4 },
];

// HEADER DATA
export const headerData = [
  { name: "About account", url: "/en/login", id: 1 },
  { name: "Markets", url: "/en/register", id: 3 },
  { name: "Trade", url: "/en/login", id: 4 },
  { name: "About us", url: "/about", id: 5 },
  { name: "Service", url: "/service", id: 6 },
  { name: "News", url: "/news", id: 7 },
  { name: "Support", url: "/support", id: 8 },
];

export const tradingPriviledges = [
  {
    name: "Power of MT5 with 24/7 trading",
    msg: `${domain} MT5 brings you the world’s favourite platform with the widest range of forex, stocks, commodities, cryptocurrencies, and exclusive Derived Indices with zero commissions and swap-free trading. `,
    icon: <RiSettingsFill className="text-[2rem]  text-red-500" />,
    id: "panel1",
  },
  {
    name: "Copy expert traders",
    msg: `On ${domain} cTrader, tap into the expertise of seasoned traders. Follow their strategies, and mirror their trades automatically.`,
    icon: <FaDatabase className="text-[2rem]  text-red-500" />,
    id: "panel2",
  },
  {
    name: "Sharp insights with TradingView charts",
    msg: `Deriv X gives you access to TradingView charts, with 110+ tools to analyse markets, track trends, and execute trades instantly — all from a single screen.`,
    icon: <BsFillWalletFill className="text-[2rem]  text-red-500" />,
    id: "panel3",
  },
  {
    name: "Optimised payouts, limited downsides",
    msg: `On ${domain} Trader, you’ll never lose more than you put in. Know your maximum risk upfront when trading global markets and round-the-clock indices.`,
    icon: <FaBtc className="text-[2rem]  text-red-500" />,
    id: "panel4",
  },
  {
    name: "Automate your trades",
    msg: `${domain} Bot keeps your strategies running on 24/7 exclusive indices and traditional markets. Trade with predetermined risk - no surprises, no coding required.`,
    icon: <FaBtc className="text-[2rem]  text-red-500" />,
    id: "panel5",
  },
];

export const whyChooseUs = [
  {
    name: "Transparent Pricing",
    msg: "There are no hidden charges or fees that are not made known to you by your account manager. We have streamlined all our packages to suit perfectly well into all your needs, making considerations to accommodate you at every point.",

    icon: <IoPricetag className="text-[3rem] mx-auto text-gray-500" />,
    id: 1,
  },

  {
    name: "Safe & Secure",
    msg: "We have upgraded our system to a PCI/DSS complaint level, making every account to have a two factor authentication and a brute force attack protection. Be rest assured that your data, funds are safe in the hands of certified experts.",

    icon: <GrSecure className="text-[3rem] mx-auto text-gray-500" />,
    id: 2,
  },

  {
    name: "Incredible Infrastructure",
    msg: "Unlike other platforms, we are fully built on a No.1 infrastructure to ensure the best result delivery. Cryptonite markets is a certified PCI/DSS company, meaning that we have attained the level of security used by such companies as MasterCard, Visa, AMEX etc",
    icon: <FaBuildingShield className="text-[3rem] mx-auto text-gray-500" />,
    id: 3,
  },

  {
    name: "Fully Encrypted",
    msg: "All data on Cryptonite markets are fully encrypted on a one way hashing algorithm. This means that only you and our server knows what inputs you made and that which you did not make. This helps to ensure that all your funds remains yours and safe",
    icon: <SiLetsencrypt className="text-[3rem] mx-auto text-gray-500" />,
    id: 4,
  },
];

// DASHBOARD FRAGMENT UI
export const dashboardFooterData = [
  {
    name: "Home",
    url: "/dashboard",
    comp: <IoHomeSharp className="df-icon-stye" />,
    id: 1,
  },
  {
    name: "Activity",
    url: "/dashboard/activity",
    comp: <LuActivity className="df-icon-stye" />,
    id: 2,
  },

  {
    name: "Profile",
    url: "/dashboard/profile",
    comp: <MdManageAccounts className="df-icon-stye" />,
    id: 4,
  },
];

// DASHBOARD FRAGMENT UI
export const adminDashboardFooterData = [
  {
    name: "Home",
    url: "/admin-dashboard",
    comp: <FaWallet className="df-icon-stye" />,
    id: 1,
  },
  {
    name: "Users",
    url: "/admin-dashboard/users",
    comp: <FaUsers className="df-icon-stye" />,
    id: 2,
  },

  {
    name: "Profile",
    url: "/admin-dashboard/profile",
    comp: <IoSettings className="df-icon-stye" />,
    id: 4,
  },
];

export const secretQuestions = [
  { name: "In what city were you born?", id: 1 },
  { name: "What is the name of your favorite pet?", id: 2 },
  { name: "What high school did you attend?", id: 3 },
  { name: "What was your favorite food as a child?", id: 4 },
  { name: "What color do you like the most?", id: 5 },
  { name: "What is your favorite artist name?", id: 6 },
];

export const walletTypes = [
  { name: "btc", id: 1 },
  { name: "eth", id: 2 },
  { name: "usdt", id: 3 },
];

// BTC

// bc1qzlqcsskdznqf6yd4w87l7askfteu4wkcmgex63

// USDT(Trc)

// TBYA1E5qZBue6XFMdShmzgE31iAF1kC3nH

// USDT (eth)

// 0xB91D00440E338CF4242cd99603aAB693fFdD0a56

// ETH (erc)

// 0xB91D00440E338CF4242cd99603aAB693fFdD0a56

// Trx

// TBYA1E5qZBue6XFMdShmzgE31iAF1kC3nH

// Bitcoin
// bc1qpz5sx7myd2pvv2twu5udan3aau440a73hzhyvw

// USDT TRC20
// TWLuvnzjCRDPHa38NJXAybVz4mpryyh9MD

// ethereum
// 0x83d354eB06b8A6987dAF7bdd0d63929232D072eb

// BNB wallet
// 0x83d354eB06b8A6987dAF7bdd0d63929232D072eb

// XRP
// raYWh4Grk35yNjDoWUCCbpkBqkDfwCFg2M

// USDC ETH
// 0x83d354eB06b8A6987dAF7bdd0d63929232D072eb

// Solana
// 7H4uoNaFuV1vDh1xz5GhDsG6wfAqRwwbKYnGKjtk6EjP

// Litecoin
// LPgqYyXXbdXP55LSCAaYZNJzSxqivopYTK

export const adminWalletData = [
  {
    walletType: "BTC",
    network: "BTC",
    walletAddr: "bc1q27w8zdw7xzlvz5kkzyre9un8k3v6ewxv72l9q4",
    id: 1,
  },
  {
    walletType: "ETH",
    network: "ERC20",
    walletAddr: "0x969eFBEAdf2f430Ad419010f8385Fb4a9B30Fb4f",
    id: 2,
  },
  {
    walletType: "USDT",
    network: "TRC20",
    walletAddr: "TUa98PTdqxbATg9iZeK3FZiKsZG75iPuen",
    id: 3,
  },

  {
    walletType: "Solana",
    network: "SOL",
    walletAddr: "2iTcLocgXwGFgyp6tcvx4ug8beeecKRnHf3pMb5Zrii7",
    id: 4,
  },
  {
    walletType: "Litecoin",
    network: "LTC",
    walletAddr: "LgDj5bqVTWgxtuRwbsaCmmy5koj5QinToa",
    id: 5,
  },
];

// {
//   walletType: "usdt",
//   network: "eth",
//   walletAddr: "0xB91D00440E338CF4242cd99603aAB693fFdD0a56",
//   id: 3,
// },

// {
//   walletType: "Trx",
//   network: "",
//   walletAddr: "TBYA1E5qZBue6XFMdShmzgE31iAF1kC3nH",
//   id: 3,
// },

// PAGE FOOTER DATA
export const footerData = [
  {
    head: "Company",
    children: [
      { name: "About", url: "/about", id: 1 },

      { name: "Legal & Privacy", url: "/privacy", id: 5 },
      { name: "Cookie policy", url: "/cookiePolicy", id: 6 },
    ],
    id: 1,
  },

  {
    head: "Support",
    children: [
      { name: "Help center", url: "help", id: 1 },
      { name: "Contact us", url: "/contact", id: 2 },
      { name: "Supportd crypto", url: "/supportedCrypto", id: 3 },
    ],
    id: 2,
  },

  {
    head: "Individual",
    children: [
      { name: "Buy & sell", url: "/about", id: 1 },
      { name: "Earn free crypto", url: "/careers", id: 2 },
      { name: "Wallet", url: "/blog", id: 3 },
    ],
    id: 3,
  },

  {
    head: "Business",
    children: [
      { name: "Institutional", url: "/about", id: 1 },
      { name: "Prime", url: "/careers", id: 2 },
      { name: "Asset Hub", url: "/blog", id: 3 },
      { name: "commerce", url: "/press", id: 4 },
    ],
    id: 4,
  },
  {
    head: "Learn",
    children: [
      { name: "Bitcoin Halving", url: "/btc-halving", id: 1 },
      { name: "What is cypto", url: "/explore", id: 4 },
      { name: "What is bitcoin", url: "/explore", id: 5 },
      { name: "What is blockchain", url: "/explore", id: 6 },
    ],
    id: 5,
  },
  {
    head: "Update",
    children: [
      { name: "Recent news", url: "/btc-halving", id: 1 },
      { name: "Previous news", url: "/careers", id: 2 },
    ],
    id: 6,
  },
];
// osnfdoibrenk
export const mediaHandles = [
  { name: "messenger", icon: "", id: 1 },
  { name: "instagram", icon: "", id: 2 },
  { name: "whatsapp", icon: "", id: 3 },
];

export const countries = [
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AS", name: "American Samoa" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antarctica" },
  { code: "AG", name: "Antigua and Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BV", name: "Bouvet Island" },
  { code: "BR", name: "Brazil" },
  { code: "IO", name: "British Indian Ocean Territory" },
  { code: "BN", name: "Brunei Darussalam" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "CV", name: "Cabo Verde" },
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "KY", name: "Cayman Islands" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CX", name: "Christmas Island" },
  { code: "CC", name: "Cocos (Keeling) Islands" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo" },
  { code: "CD", name: "Congo, Democratic Republic of the" },
  { code: "CK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Curaçao" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czech Republic" },
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Ethiopia" },
  { code: "FK", name: "Falkland Islands" },
  { code: "FO", name: "Faroe Islands" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GF", name: "French Guiana" },
  { code: "PF", name: "French Polynesia" },
  { code: "TF", name: "French Southern Territories" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GI", name: "Gibraltar" },
  { code: "GR", name: "Greece" },
  { code: "GL", name: "Greenland" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HM", name: "Heard Island and McDonald Islands" },
  { code: "VA", name: "Holy See" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JE", name: "Jersey" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KP", name: "Korea, Democratic People's Republic of" },
  { code: "KR", name: "Korea, Republic of" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LA", name: "Lao People's Democratic Republic" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MO", name: "Macao" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NC", name: "New Caledonia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NF", name: "Norfolk Island" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestinian Territory" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PN", name: "Pitcairn" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RE", name: "Réunion" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russian Federation" },
  { code: "RW", name: "Rwanda" },
  { code: "BL", name: "Saint Barthélemy" },
  { code: "SH", name: "Saint Helena" },
  { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin (French part)" },
  { code: "PM", name: "Saint Pierre and Miquelon" },
  { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "Sao Tome and Principe" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten (Dutch part)" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard and Jan Mayen" },
  { code: "SZz", name: "Eswatini" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syrian Arab Republic" },
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turkey" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TC", name: "Turks and Caicos Islands" },
  { code: "TV", name: "Tuvalu" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "WF", name: "Wallis and Futuna" },
  { code: "EH", name: "Western Sahara" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
  // You can add more countries if needed
];

export const ourNumbers = [
  { name: "24H Trading Volume (USD)", value: "20,000,000,000+", id: 1 },
  { name: "Cryptocurrencies Listed", value: "1,800+", id: 2 },
  { name: "Registered Users", value: "50,000+", id: 3 },
  { name: "Supported Countries", value: "130+", id: 4 },
  { name: "Customer Support", value: "24/7", id: 5 },
  { name: "PCI DSS & Multiple regulatory licenses", value: "Certified", id: 6 },
];

export const tradingStrategies = [
  {
    strategy: "Swing Trading",
    profitPotential: "5-15% per trade",
    lossPotential: "-2 to -8% per trade",
    winRate: "50-60%",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon sx={{ color: "darkred" }} />,
    profitIcon: <TrendingUpIcon sx={{ color: "darkgreen" }} />,
    winIcon: <EmojiEventsIcon />,
    id: 1,
  },
  {
    strategy: "Day Trading",
    profitPotential: "1-3% per trade",
    lossPotential: "-1 to -2% per trade",
    winRate: "45-55%",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 2,
  },
  {
    strategy: "Scalping",
    profitPotential: "0.1-0.5% per trade",
    lossPotential: "-0.1 to -0.5% per trade",
    winRate: "60-70%",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 3,
  },
  {
    strategy: "Position Trading",
    profitPotential: "20-50% per year",
    lossPotential: "Varies widely, typically -10 to -25% per major trade",
    winRate: "60-70%",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 4,
  },
  {
    strategy: "Momentum Trading",
    profitPotential: "10-30% per trade",
    lossPotential: "-5 to -15% per trade",
    winRate: "50-65%",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 5,
  },
  {
    strategy: "Mean Reversion",
    profitPotential: "5-20% per trade",
    lossPotential: "-3 to -10% per trade",
    winRate: "50-60%",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 6,
  },
  {
    strategy: "Algorithmic Trading",
    profitPotential: "Varies widely (1-20% monthly depending on strategy)",
    lossPotential: "Varies widely, can have significant drawdowns",
    winRate: "Depends on the algorithm used",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 7,
  },
  {
    strategy: "Options Trading",
    profitPotential: "Highly variable; can be 100%+",
    lossPotential: "Can lose entire investment if options expire worthless",
    winRate: "Varies greatly but generally lower",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 8,
  },
  {
    strategy: "Value Investing",
    profitPotential: "10-20% annually",
    lossPotential:
      "Varies; potential for significant drawdowns in bear markets",
    winRate: "High eventually, often pays off in the long term",
    strategyIcon: <OnlinePredictionIcon />,
    lossIcon: <TrendingDownIcon />,
    profitIcon: <TrendingUpIcon />,
    winIcon: <EmojiEventsIcon />,
    id: 9,
  },
];

export const commitmentComp = [
  {
    icon: <GroupWorkIcon />,
    hd: "Triple-Layer Asset Protection",
    msg: "User's fnuds are stored securely offline in cold wallets.",
    id: 1,
  },
  {
    icon: <ShieldIcon />,
    hd: "Privacy Protection",
    msg: "We integrate a privacy-first philosophy into all our products and services.",
    id: 2,
  },
  {
    icon: <AnalyticsIcon />,
    hd: "Advanced data Protection",
    msg: "Data is encrypted both in storage and in transit.",
    id: 3,
  },
  {
    icon: <InsightsIcon />,
    hd: "Real-Time Monitoring",
    msg: "Bybit's risk controls monitor and analyze user behavior in real-time.",
    id: 4,
  },
  {
    icon: <LockIcon />,
    hd: "Security by Design",
    msg: "Our system prioritizes security, following a secure development life cycle.",
    id: 5,
  },
];

export const needHelp = [
  {
    icon: <SupportAgentIcon />,
    hd: "24/7 Customer Support",
    msg: "Get 24/7 support from our friendly customer support agents",
    id: 1,
  },
  {
    icon: <LiveHelpIcon />,
    hd: "FAQ'S",
    msg: "Explor FAQ'S for detailed instructions on specific features.",
    id: 2,
  },
  {
    icon: <LocalLibraryIcon />,
    hd: "Learn",
    msg: "Discover a range of trading guides tailored for beginners and advanced traders alike",
    id: 3,
  },
];

// export const minerData = [
// 	{
// 		title: "Miner 1",
// 		desc: "low power consumption and modest returns.",
// 		hashRate: 30,
// 		hashRateUnit: "TH/s",
// 		dailyEarning: ">$350.00",
// 		withdrawalThreshold: "$1,000",
// 		weeklyPayout: ">$3,000.00 ",
// 		withdrawal: "Anytime",
// 		price: 200,

// 		logo: <GiMiner />,
// 		id: 1,
// 	},
// 	{
// 		title: "Miner 2",
// 		desc: "More powerful, better for steady mining; higher electricity costs but increased earnings.",
// 		hashRate: 60,
// 		dailyEarning: ">$610.00",
// 		weeklyPayout: ">$4,100.00 ",
// 		withdrawal: "weekly",
// 		price: 800,
// 		logo: <GiMiner />,
// 		id: 2,
// 	},
// 	{
// 		title: "Miner 3",
// 		desc: " High-performance hardware, more profitable but consumes more electricity and requires better cooling.",
// 		hashRate: 150,
// 		dailyEarning: ">$1,100.00",
// 		weeklyPayout: ">$7,600.00 ",
// 		withdrawal: "weekly",
// 		price: 1500,
// 		logo: <GiMiner />,
// 		id: 3,
// 	},
// ];

// Log the strategies to the console
// console.log(tradingStrategies);

export const minerData = [
  {
    title: "Miner 1",
    desc: "Low power consumption and modest returns.",
    hashRate: 10,
    hashRateUnit: "TH/s",
    dailyEarning: "$3 - $5", // Use a range for realism
    withdrawalThreshold: "Anyamount",
    weeklyPayout: "$8 - $20", // Also use a range
    withdrawal: "Anytime",
    price: 1,
    powerConsumption: "1000 W", // Add power consumption
    estimatedROI: "18-24 months", // Crucial addition
    logo: <GiMiner />,
    id: 1,
  },
  {
    title: "Miner 2",
    desc: "Average power consumption and high returns.",
    hashRate: 30,
    hashRateUnit: "TH/s",
    dailyEarning: "$300 - $350", // Use a range for realism
    withdrawalThreshold: "$1,000",
    weeklyPayout: "$2,000 - $2,500", // Also use a range
    withdrawal: "Anytime",
    price: 200,
    powerConsumption: "1000 W", // Add power consumption
    estimatedROI: "18-24 months", // Crucial addition
    logo: <GiMiner />,
    id: 2,
  },
  {
    title: "Miner 3",
    desc: "More powerful, better for steady mining; higher electricity costs but increased earnings.",
    hashRate: 60,
    hashRateUnit: "TH/s",
    dailyEarning: "$900 - $1,600",
    withdrawalThreshold: "$2,000",
    weeklyPayout: "$4,000 - $4,500",
    withdrawal: "Weekly",
    price: 500,
    powerConsumption: "2000 W",
    estimatedROI: "12-18 months",
    logo: <GiMiner />,
    id: 3,
  },
  {
    title: "Miner 4",
    desc: "High-performance hardware, more profitable but consumes more electricity and requires better cooling.",
    hashRate: 420,
    hashRateUnit: "TH/s",
    dailyEarning: "$5,200 - $9,000",
    withdrawalThreshold: "$15,000",
    weeklyPayout: "$50,000 - $100,000",
    withdrawal: "Weekly",
    price: 2500,
    powerConsumption: "3500 W",
    estimatedROI: "9-12 months",
    logo: <GiMiner />,
    id: 4,
  },
];

export const footerMsgData = [
  {
    name: `${domain} Investments (Europe) Limited is licensed and regulated by the Malta Financial Services Authority under the Investment Services Act.`,
    id: 1,
  },
  {
    name: `${domain} (FX) Ltd is licensed by the Labuan Financial Services Authority.`,
    id: 2,
  },
  {
    name: `${domain} (BVI) Ltd is licensed by the British Virgin Islands Financial Services Commission.`,
    id: 3,
  },

  {
    name: `${domain} (V) Ltd is licensed and regulated by the Vanuatu Financial Services Commission.`,
    id: 4,
  },
  {
    name: `${domain} (Mauritius) Ltd is licensed by the Financial Services Commission, Mauritius.`,
    id: 5,
  },
  {
    name: `${domain} (SVG) LLC has a registered office at First Floor, SVG Teachers Credit Union Uptown Building, Corner of James and Middle Street, Kingstown P.O., St Vincent and the Grenadines.`,
    id: 5,
  },
  {
    name: `${domain}.com Limited, a company registered in Guernsey, is the holding company for these entities.`,
    id: 6,
  },
];

export const dataset = [
  {
    BTC: 35,
    ETH: 24,
    LTC: 53,
    XRP: 32,
    month: "Jan",
  },
  {
    BTC: 35,
    ETH: 54,
    LTC: 43,
    XRP: 32,
    month: "Feb",
  },
  {
    BTC: 25,
    ETH: 32,
    LTC: 24,
    XRP: 52,
    month: "Mar",
  },
  {
    BTC: 25,
    ETH: 34,
    LTC: 23,
    XRP: 32,
    month: "Apr",
  },
  { BTC: 20, ETH: 30, LTC: 33, XRP: 20, month: "May" },
  {
    BTC: 25,
    ETH: 30,
    LTC: 23,
    XRP: 32,
    month: "June",
  },
  { BTC: 25, ETH: 34, LTC: 23, XRP: 42, month: "July" },
  { BTC: 27, ETH: 34, LTC: 43, XRP: 42, month: "Aug" },
  { BTC: 32, ETH: 34, LTC: 23, XRP: 20, month: "Sept" },
  {
    BTC: 50,
    ETH: 40,
    LTC: 43,
    XRP: 20,
    month: "Oct",
  },
  {
    BTC: 50,
    ETH: 40,
    LTC: 23,
    XRP: 42,
    month: "Nov",
  },
  {
    BTC: 21,
    ETH: 30,
    LTC: 39,
    XRP: 45,
    month: "Dec",
  },
];

export function valueFormatter(value) {
  return `${value}USD`;
}

export const alphabetStock = [
  {
    date: "2023-07-24",
    open: 121.660004,
    high: 123.0,
    low: 120.980003,
    close: 121.529999,
    adjClose: 121.390678,
    volume: 29686100,
  },
  {
    date: "2023-07-25",
    open: 121.360001,
    high: 123.150002,
    low: 121.019997,
    close: 122.209999,
    adjClose: 122.069901,
    volume: 52509600,
  },
  {
    date: "2023-07-26",
    open: 130.070007,
    high: 130.979996,
    low: 128.320007,
    close: 129.270004,
    adjClose: 129.121811,
    volume: 61682100,
  },
  {
    date: "2023-07-27",
    open: 131.669998,
    high: 133.240005,
    low: 128.789993,
    close: 129.399994,
    adjClose: 129.251648,
    volume: 44952100,
  },
  {
    date: "2023-07-28",
    open: 130.779999,
    high: 133.740005,
    low: 130.570007,
    close: 132.580002,
    adjClose: 132.428009,
    volume: 36591200,
  },
  {
    date: "2023-07-31",
    open: 132.729996,
    high: 133.529999,
    low: 131.779999,
    close: 132.720001,
    adjClose: 132.567856,
    volume: 28055500,
  },
  {
    date: "2023-08-01",
    open: 130.779999,
    high: 132.630005,
    low: 130.679993,
    close: 131.550003,
    adjClose: 131.3992,
    volume: 23166800,
  },
  {
    date: "2023-08-02",
    open: 129.449997,
    high: 130.089996,
    low: 127.559998,
    close: 128.380005,
    adjClose: 128.232834,
    volume: 26273300,
  },
  {
    date: "2023-08-03",
    open: 127.970001,
    high: 129.389999,
    low: 127.419998,
    close: 128.449997,
    adjClose: 128.30275,
    volume: 20089500,
  },
  {
    date: "2023-08-04",
    open: 129.279999,
    high: 131.509995,
    low: 127.910004,
    close: 128.110001,
    adjClose: 127.963135,
    volume: 26130000,
  },
];
